import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private domSanitized: DomSanitizer) {
  }

  transform(value: any, args?: any): any {
    return this.domSanitized.bypassSecurityTrustHtml(value);
  }

}



@Pipe({
  name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {

  constructor(private domSanitized: DomSanitizer) {
  }

  transform(value: any, args?: any): any {
    return this.domSanitized.bypassSecurityTrustResourceUrl(value);
  }

}

@Pipe({
  name: 'urlify',
})
export class UrlifyPipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  transform(value: any, args?: any): SafeHtml {
    const urlRegex =
      /(\b(https?|ftp|file):\/\/[-A-Z\d+&@#/%?=~_|!:,.;]*[-A-Z\d+&@#/%=~_|])/gi;

      let html = value;

      if (value) {
        html  = value?.replace(
          urlRegex,
          (url) => `<a href="${url}" target="_blank" onclick="event.stopPropagation();">${url}</a>`
        );
      }
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }
}

@Pipe({
  name: 'secondsToTime'
})
export class SecondsToTime implements PipeTransform {

  transform(value: number): string {
    if (!value) {
      return '00:00:00';
    }
    const hours = Math.floor(value / 3600);
    value %= 3600;
    const minutes = Math.floor(value / 60);
    const seconds = value % 60;
    return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  }

}
